var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 29.523,
  height: 23.278,
  viewBox: "0 0 29.523 23.278"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-17.529 -22.087)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.674,33.177,27.1,43.116l18.862-20",
  fill: "none",
  stroke: "#eb7d3c",
  strokeWidth: 3
}))));
export default SvgIconCheck;